import * as React from 'react';
import { __ } from '../../helpers/TranslationService';
import { ISearchReducer } from '../../reducers/search';
import { SelectDropdown } from './SelectDropdown';
import { transformOptions } from '../../helpers/searchHelpers';

const style: Record<string, React.CSSProperties> = {
    containerStyle: {
        position: 'relative',
        zIndex: 4,
    },
};

interface OwnProps {
    ship: string;
    zone: string;
    search: ISearchReducer;
    onShipChange(param: any): void;
    onZoneChange(param: any): void;
}

type IProps = OwnProps;

export const ShipInputSelection = function (IProps) {
    const defaultZoneOptions = { value: 'default', label: __('Any Destination', 'dreamlines') };
    const defaultShipOptions = { value: 'default', label: __('All ships', 'dreamlines') };
    const { zoneNids, topZones } = IProps.search.searchFacets;

    const zoneNidData = transformOptions(
        defaultZoneOptions,
        zoneNids,
        topZones,
        __('Top Zones', 'dreamlines'),
        __('Any Destination', 'dreamlines'),
    );

    const { shipNids } = IProps.search.searchFacets.shipNids.length
        ? IProps.search.searchFacets
        : IProps.search.searchFacetsAll;

    const shipNidData = [defaultShipOptions].concat(
        shipNids?.map((val) => ({
            value: val.id.toString(),
            label: `${val.title} (${val.count || IProps.numResults})`,
        })),
    );

    return (
        <div style={style.containerStyle}>
            <SelectDropdown
                nids={shipNidData}
                onChange={IProps.onShipChange}
                value={IProps.ship}
                searchPlaceholder="Type in a ship name"
                searchable
            />
            <SelectDropdown
                nids={zoneNidData}
                onChange={IProps.onZoneChange}
                value={IProps.zone}
                searchPlaceholder="Type in a destination"
                searchable
            />
        </div>
    );
};
